import { render } from "./DeansComplianceChecking.vue?vue&type=template&id=06108296"
import script from "./DeansComplianceChecking.vue?vue&type=script&lang=js"
export * from "./DeansComplianceChecking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__